import { useContext } from 'react';
import { MergeTagsContext } from './MergeTagsContext';

export const useMergeTagsContext = () => {
  const mergeTagsContext = useContext(MergeTagsContext);
  if (mergeTagsContext === undefined) {
    throw new Error('useMergeTagsContext must be inside a MergeTagsProvider');
  }
  return mergeTagsContext;
};
